import { Badge, Box, Button, Checkbox, ColumnLayout, Container, FileUpload, Form, FormField, Header, Input, Link, Modal, Select, SelectProps, SpaceBetween, StatusIndicator, TokenGroup } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { CustomAppLayout, saveMasters } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
////import { useStoreAdmin } from '../../../context/useStoreAdmin';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { formatRut, validateRut } from '@fdograph/rut-utilities';
import Copy from '../../../../../components/Copy';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import SelectCategory from '../../../../../components/selects/selectCategory';
import SelectEquipment from '../../../../../components/selects/selectEquipment';
import SelectGroupType from '../../../../../components/selects/selectGroupType';
import UserPicker from '../../../../../components/UserPicker';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemEquipment } from '../../../../../resources/types';
import { addNotificationStatus, buildBreadcrumbItems, fileToBase64, getCookie, getParameter, getUrlVersion, getUser, sanitizeNumber, scrollToTop, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';

const pageSize = 20;
type OptionDefinition = SelectProps.Option;
interface AltitudeItem {
    idEquipment: number;
    altitude: string;
    cost: string;
}

interface Make {
    idMake: number;
    make: string;
    models: { idModel: number; model: string }[];
}
interface Props {
    data: { makes: Make[] };
    equipment: ItemEquipment;          // <-- reuse your existing type
    setEquipment: (eq: ItemEquipment) => void;  // update function
}

export const MasterEquipmentsEquipmentPage = () => {
    const { data, menu, parameters } = useGlobalState();
    const [equipment, setEquipment] = useState<ItemEquipment>();


    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();

    const [OOFStart, setOOFStart] = useState<boolean>(false);

    const [showImage, setShowImage] = useState<boolean>(false);
    const [OOFEnd, setOOFEnd] = useState<boolean>(false);
    const [userPickerModal, setUserPickerModal] = useState<boolean>(false);

    const [init, setInit] = useState(false);
    const [owners, setOwners] = useState<{ label: string; value: number }[]>([]);
    const [makes, setMakes] = useState<any[]>([]);
    const returnURL = getParameter(window.location.hash, 'returnURL');

    const [hourCost, setHourCost] = useState(equipment?.hourCost.toString());
    const [hourCostFree, setHourCostFree] = useState(equipment?.hourCostFree.toString());
    useEffect(() => {

        if (equipment && equipment.jsonOwners) {
            const mapped = equipment.jsonOwners.map((id: number) => {
                const user = getUser(id, data);
                return {
                    label: user?.displayName || "", // shown in TokenGroup
                    value: id,               // keep original ID
                };
            });
            setOwners(mapped);
        }
    }, [equipment?.jsonOwners]);


    const handleFileChange = async (files: File[]) => {
        try {
            // Use Promise.all to concurrently convert all files to Base64
            const base64Results = await Promise.all(files.map(fileToBase64));
            try {
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/equipments/update',
                        'JWT': getCookie("JWT"),
                    },

                    body: JSON.stringify({
                        idEquipment: equipment?.idEquipment,
                        image: base64Results[0].base64, // assuming single file upload
                    })
                });
                if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

                const data = await response.json();
                if (data && data.equipment) { setEquipment(data.equipment) }
            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        } catch (error) {
            console.error('Error reading files:', error);
            // Handle error state if necessary
        }
    };
    useEffect(() => {
        handleGetEquipment()
    }, [parameters.idEquipment]);
    const handleRUTFormat = () => {
        if (equipment?.jsonSII & equipment?.jsonSII.rut) {
            //setRUT(formatRut(rut))
        }
    }
    const towTypestring = ((t: string) => {
        if (t == "BALLAST") return "Lastre";
        else if (t == "SANRAMON") return "San Ramón";
        else if (t == "MOUNTAIN") return "Cordillera";
        else if (t == "LOCAL") return "Local";
        return "";
    })
    const handleEquipmentUpdate = async () => {
        try {
            setLoading(true);
            if (equipment) {
                equipment.image = "";
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/equipments/update',
                    'JWT': getCookie("JWT"),
                },

                body: JSON.stringify({
                    ...equipment,
                    masters: ["equipments"],
                })
            });
            if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

            const data = await response.json();
            if (data && data.equipment) { setEquipment(data.equipment) }
            addNotificationStatus(data, setData);
            if (data.code === 0) {
                scrollToTop();
                if (data.masters)
                    saveMasters(data.masters, setData);
            }

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }

    }
    const handleGetEquipment = async () => {
        try {
            if (parameters.idEquipment > 0) {
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/equipments/get',
                        'JWT': getCookie("JWT"),

                    },

                    body: JSON.stringify({
                        idEquipment: parameters.idEquipment,
                        makes: 1,
                        image: true,
                    })
                });
                if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

                const dataWeb = await response.json();
                if (dataWeb && dataWeb.equipment) {
                    setEquipment(dataWeb.equipment)
                    setHourCost(dataWeb.equipment.hourCost)
                    setHourCostFree(dataWeb.equipment.hourCostFree)
                    if (dataWeb.makes) {
                        setMakes(dataWeb.makes);
                    }
                }
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };


    const [selectedMake, setSelectedMake] = useState<any>(null);
    const [selectedModel, setSelectedModel] = useState<any>(null);

    useEffect(() => {
        if (equipment && data.makes) {
            if (equipment.idModel && data.makes.length > 0) {
                const foundMake = data.makes.find((m: { models: any[]; }) =>
                    m.models.some(mod => mod.idModel === equipment.idModel)
                );
                if (foundMake) {
                    setSelectedMake({
                        label: foundMake.make,
                        value: foundMake.idMake.toString(),
                    });
                    const foundModel = foundMake.models.find(
                        (mod: { idModel: number; }) => mod.idModel === equipment.idModel
                    );
                    if (foundModel) {
                        setSelectedModel({
                            label: foundModel.model,
                            value: foundModel.idModel.toString(),
                        });
                    }
                }
            }
        }
    }, [equipment?.idModel]);

    const handleModelChange = (detail: any) => {
        if (equipment) {
            const idModel = Number(detail.selectedOption.value);
            setSelectedModel(detail.selectedOption);
            setEquipment({ ...equipment, idModel });
        }
    };
    const handleCostChange = (index: number, value: string) => {
        if (!equipment?.jsonAltitudes) return;

        const updatedAltitudes = equipment.jsonAltitudes.map(
            (item: AltitudeItem, idx: number) =>
                idx === index ? { ...item, cost: value } : item
        );
        setEquipment({ ...equipment, jsonAltitudes: updatedAltitudes });
    };

    const handleTowingChange = (season: any, key: any, newValue: any) => {
        setEquipment({
            ...equipment,
            jsonTowingTimes: {
                ...equipment.jsonTowingTimes,
                [season]: {
                    ...equipment.jsonTowingTimes[season],
                    [key]: Number(newValue) // Convert string input to number
                }
            }
        });
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="xs">
                    <Header actions={


                        <SpaceBetween direction="horizontal" size="xs">
                            <SelectEquipment value={parameters?.idEquipment || 0} onConfirm={(detail) => {
                                if (detail) {
                                    const updatedParameters = {
                                        ...parameters, // clone existing keys
                                        idEquipment: Number(detail.idEquipment)
                                    };
                                    setParameters(updatedParameters); // updates state + storage
                                } else {


                                    const updatedParameters = {
                                        ...parameters, // clone existing keys
                                        idEquipment: Number(0)
                                    };
                                    setParameters(updatedParameters); // updates state + storage
                                    setEquipment(undefined);
                                }



                            }} />
                            <Button
                                key={"btnAdd"}
                                onClick={() => setEquipment({
                                    idEquipment: 0,
                                    registration: "",
                                    idCategory: 1,
                                    idGroupType: 0,
                                    idModel: 0,
                                    timeCount: "TIME",
                                    equipment: "",
                                    jsonSII: {},
                                    jsonOwners: [],
                                    isBookCapable: 0,
                                    isClub: 0,
                                    isActiveEquipment: 1,
                                    isDeleteEquipment: 0,
                                    isInvoice: 0,
                                    isMant: 0,
                                    isOutOfFlight: 0,
                                    outOfFlightStart: "",
                                    outOfFlightEnd: "",
                                    hourCost: 0,
                                    hourCostFree: 0,
                                    jsonAltitudes: [],
                                    groupTypeMasterCode: "",
                                    jsonTowingTimes: { inseason: {}, outseason: {} },
                                } as unknown as ItemEquipment)}
                            >Agregar</Button>
                            <Favorites />
                        </SpaceBetween>
                    }>Aeronaves
                    </Header>
                    {equipment && (
                        <Form actions={
                            <Box textAlign="right">
                                <Button variant='primary' onClick={() => handleEquipmentUpdate()}>{equipment.idEquipment === 0 ? "Ingresar" : "Actualizar"}</Button>
                            </Box>
                        }>
                            <SpaceBetween direction="vertical" size="s">
                                <Container header={
                                    <Header variant='h3' actions={
                                        <Box><Copy value={equipment.idEquipment.toString()} /></Box>
                                    }>Información</Header>
                                }>
                                    <SpaceBetween direction="horizontal" size="l">
                                        <FormField label="Matrícula">
                                            <Input value={equipment.registration} readOnly={equipment.idCategory === 0}

                                                onChange={(detail) => {
                                                    if (detail) {
                                                        const updatedEquipmenet = { ...equipment, registration: detail.detail.value.toUpperCase() };
                                                        setEquipment(updatedEquipmenet);
                                                    }
                                                }}
                                            />
                                        </FormField>
                                        <FormField label="Categoría">
                                            <SelectCategory single value={equipment.idCategory} onSelect={(idCategory) => {
                                                const updatedEquipmenet = { ...equipment, idCategory: Number(idCategory) };
                                                setEquipment(updatedEquipmenet);
                                            }} />
                                        </FormField>
                                        <FormField label="Grupo">
                                            <SelectGroupType single showOnBooking={0} value={equipment.idGroupType} onSelect={(idGroupType) => {
                                                const updatedEquipmenet = { ...equipment, idGroupType: Number(idGroupType) };
                                                setEquipment(updatedEquipmenet);
                                            }} />
                                        </FormField>
                                    </SpaceBetween>
                                    <SpaceBetween direction="horizontal" size="l">
                                        <FormField label="Tipo facturación" constraintText={<>Para efectos de cobro de vuelo,<br />si la métrica de tiempo es en base<br />a planilla u horómetro</>}>
                                            <Select
                                                onChange={({ detail }) => {
                                                    const updatedEquipmenet = { ...equipment, timeCount: detail.selectedOption?.value || "TIME" };
                                                    setEquipment(updatedEquipmenet);
                                                }}
                                                selectedOption={equipment.timeCount === "TIME" ? { label: "Tiempo", value: "TIME" } : { label: "Horómetro", value: "2" }}
                                                options={[
                                                    { label: "Tiempo", value: "TIME" },
                                                    { label: "Horómetro", value: "TAC" },
                                                ]}
                                            />
                                        </FormField>
                                        <FormField label={"RUT facturación"} constraintText={<>Para ingreso de combustibles, RUT<br />alternativo a emitir factura</>}>
                                            <Input value={equipment.jsonSII.rut || ""}
                                                onBlur={handleRUTFormat}
                                                invalid={equipment.jsonSII && equipment.jsonSII.rut && !validateRut(equipment.jsonSII.rut) && equipment.jsonSII.rut.length > 0}
                                                onChange={(detail) => {
                                                    if (detail) {
                                                        if (validateRut(detail.detail.value)) {
                                                            detail.detail.value = formatRut(detail.detail.value.toUpperCase())
                                                        }
                                                        const updatedEquipment = {
                                                            ...equipment, jsonSII: { ...equipment.jsonSII, rut: detail.detail.value },
                                                        };
                                                        setEquipment(updatedEquipment);
                                                    }
                                                }}

                                            />
                                        </FormField>
                                        <FormField label={"Descriptivo"} constraintText={<>Para material no aeronautico, descripción<br />alternativa a la matrícula</>}>
                                            <Input value={equipment.equipment}
                                                onChange={(detail) => {
                                                    if (detail) {
                                                        const updatedEquipmenet = { ...equipment, equipment: detail.detail.value };
                                                        setEquipment(updatedEquipmenet);
                                                    }
                                                }}
                                            />
                                        </FormField>

                                    </SpaceBetween>
                                    <SpaceBetween direction="horizontal" size="l">
                                        <FormField label={"ID Softmanto"} constraintText={"Identificador en BBDD SoftMantto"}>
                                            <Input value={(equipment.idEquipmentSoftMantto ?? 0).toString()}
                                                onChange={(detail) => {
                                                    if (detail) {
                                                        const updatedEquipmenet = { ...equipment, idEquipmentSoftMantto: parseInt(detail.detail.value) };
                                                        setEquipment(updatedEquipmenet);
                                                    }
                                                }}
                                            />
                                        </FormField>
                                        <FormField label={"Max PAX"} constraintText={<>Alerta sobre limite de capacidad.<br />0 deshabilita</>}>
                                            <Input value={(equipment.maxPAX ?? 0).toString()}
                                                onChange={(detail) => {
                                                    if (detail) {
                                                        const updatedEquipmenet = { ...equipment, maxPAX: parseInt(detail.detail.value) };
                                                        setEquipment(updatedEquipmenet);
                                                    }
                                                }}
                                            />
                                        </FormField>
                                    </SpaceBetween>
                                    <SpaceBetween direction="horizontal" size="l">
                                        <FormField label="Fabricante">
                                            <div style={{ width: '200px' }}>
                                                <Select
                                                    selectedOption={selectedMake}
                                                    filteringType="auto"
                                                    onChange={({ detail }) => {
                                                        const idMake = Number(detail.selectedOption.value);
                                                        setSelectedMake(detail.selectedOption);
                                                        // reset model because make changed
                                                        setSelectedModel(null);
                                                        setEquipment({ ...equipment, idModel: 0 }); // clear model
                                                    }}
                                                    options={data.makes.map((m: { make: any; idMake: { toString: () => any; }; }) => ({
                                                        label: m.make,
                                                        value: m.idMake.toString(),
                                                    }))}
                                                    placeholder="Seleccionar fabricante"
                                                />
                                            </div>
                                        </FormField>

                                        <FormField label="Modelo">
                                            <div style={{ width: '200px' }}>
                                                <Select
                                                    selectedOption={selectedModel}
                                                    onChange={({ detail }) => handleModelChange(detail)}
                                                    filteringType="auto"
                                                    options={
                                                        selectedMake
                                                            ? data.makes
                                                                .find((m: { idMake: number; }) => m.idMake === Number(selectedMake.value))
                                                                ?.models.map((mod: { model: any; idModel: { toString: () => any; }; }) => ({
                                                                    label: mod.model,
                                                                    value: mod.idModel.toString(),
                                                                })) ?? []
                                                            : []
                                                    }
                                                    placeholder="Seleccionar modelo"
                                                    disabled={!selectedMake}
                                                />
                                            </div>
                                        </FormField>



                                        <FormField label="Imagen" description={
                                            <FileUpload
                                                onChange={({ detail }) => {
                                                    //setPacUniverse(detail.value)
                                                    //console.log(detail.value);
                                                    handleFileChange(detail.value);
                                                }}
                                                accept='.jpeg,.jpg'
                                                i18nStrings={{
                                                    uploadButtonText: e => "Seleccionar archivo",
                                                    dropzoneText: e => "Arrastre archivo para cargar",
                                                    removeFileAriaLabel: e => `Eliminar archivo ${e + 1}`,
                                                    limitShowFewer: "Show fewer files",
                                                    limitShowMore: "Show more files",
                                                    errorIconAriaLabel: "Error",
                                                    warningIconAriaLabel: "Warning"
                                                }}
                                                showFileLastModified
                                                showFileSize
                                                showFileThumbnail
                                                tokenLimit={1} value={[]} />
                                        }>
                                            {equipment.image && equipment.image !== "" ?
                                                <img style={{ width: 200, height: "auto", borderRadius: 10 }} src={equipment.image}
                                                    onClick={() => {
                                                        setShowImage(true);
                                                    }}
                                                />
                                                : null}
                                        </FormField>

                                    </SpaceBetween>
                                </Container>
                                {showImage && (
                                    <Modal visible={showImage} onDismiss={() => setShowImage(false)} size="large" header={<Header variant="h1">Imagen</Header>}>
                                        <img style={{ width: "100%", height: "auto", borderRadius: 10 }} src={equipment.image}
                                            onClick={() => {
                                                setShowImage(false);
                                            }}
                                        />
                                    </Modal>
                                )}
                                <Container header={
                                    <Header variant='h3'>Atributos</Header>
                                }>

                                    <SpaceBetween direction="vertical" size="xs">
                                        <SpaceBetween direction="horizontal" size="l">
                                            <Checkbox
                                                disabled={equipment.jsonOwners.length > 0}
                                                onChange={({ detail }) => {
                                                    const updatedEquipmenet = { ...equipment, isClub: detail.checked ? 1 : 0 };
                                                    setEquipment(updatedEquipmenet);
                                                }}
                                                checked={equipment.isClub === 1}>
                                                Es propiedad del club
                                            </Checkbox>

                                            {equipment.isClub === 0 && (
                                                <>
                                                    <Link onClick={() => setUserPickerModal(true)}><Badge color='blue'>Agregar</Badge></Link>

                                                    <UserPicker

                                                        visible={userPickerModal}
                                                        clear={false}
                                                        close={false}
                                                        onConfirm={(detail) => {
                                                            const userId = detail.value; // assuming detail.value = idUser

                                                            // Avoid duplicates
                                                            if (!equipment.jsonOwners.includes(Number(userId))) {
                                                                const updatedEquipment = {
                                                                    ...equipment,
                                                                    jsonOwners: [...equipment.jsonOwners, Number(userId)],
                                                                };
                                                                setEquipment(updatedEquipment);
                                                                setUserPickerModal(false)
                                                            }
                                                        }}
                                                        onDismiss={() => {
                                                            setUserPickerModal(false)
                                                        }}
                                                    />
                                                </>
                                            )}
                                        </SpaceBetween>
                                        {equipment.jsonOwners.length > 0 && equipment.isClub === 0 ?
                                            <StatusIndicator type="warning">
                                                Para asignar como propiedad del club, debe eliminar todos los propietarios
                                            </StatusIndicator>
                                            : null}
                                        {equipment.isClub === 0 && (
                                            <SpaceBetween direction="horizontal" size="l">
                                                <TokenGroup
                                                    onDismiss={({ detail: { itemIndex } }) => {
                                                        const newOwners = [
                                                            ...owners.slice(0, itemIndex),
                                                            ...owners.slice(itemIndex + 1),
                                                        ];
                                                        setOwners(newOwners);
                                                        const newJsonOwners = [
                                                            ...equipment.jsonOwners.slice(0, itemIndex),
                                                            ...equipment.jsonOwners.slice(itemIndex + 1),
                                                        ];

                                                        // 3. Update equipment
                                                        const updatedEquipment = { ...equipment, jsonOwners: newJsonOwners };
                                                        setEquipment(updatedEquipment);
                                                    }}
                                                    items={owners}
                                                />
                                            </SpaceBetween>
                                        )}


                                        <Checkbox
                                            onChange={({ detail }) => {
                                                const updatedEquipmenet = { ...equipment, syncSoftMantto: detail.checked ? 1 : 0 };
                                                setEquipment(updatedEquipmenet);
                                            }}
                                            checked={equipment.syncSoftMantto === 1}>
                                            Sincronizado con SoftMantto para bitácoras
                                        </Checkbox>

                                        <Checkbox
                                            onChange={({ detail }) => {
                                                const updatedEquipmenet = { ...equipment, isBookCapable: detail.checked ? 1 : 0 };
                                                setEquipment(updatedEquipmenet);
                                            }}
                                            checked={equipment.isBookCapable === 1}>
                                            Es reservable
                                        </Checkbox>
                                        <Checkbox
                                            onChange={({ detail }) => {
                                                const updatedEquipmenet = { ...equipment, isActiveEquipment: detail.checked ? 1 : 0 };
                                                setEquipment(updatedEquipmenet);
                                            }}
                                            checked={equipment.isActiveEquipment === 1}>
                                            Está activo
                                        </Checkbox>

                                        <Checkbox
                                            onChange={({ detail }) => {
                                                const updatedEquipmenet = { ...equipment, isInvoice: detail.checked ? 1 : 0 };
                                                setEquipment(updatedEquipmenet);
                                            }}
                                            checked={equipment.isInvoice === 1}>
                                            Es facturable
                                        </Checkbox>

                                        <Checkbox
                                            onChange={({ detail }) => {
                                                const updatedEquipmenet = { ...equipment, isMant: detail.checked ? 1 : 0 };
                                                setEquipment(updatedEquipmenet);
                                            }}
                                            checked={equipment.isMant === 1}>
                                            Sujeto a mantenimiento
                                        </Checkbox>

                                        <Checkbox
                                            onChange={({ detail }) => {
                                                const updatedEquipmenet = {
                                                    ...equipment, isOutOfFlight: detail.checked ? 1 : 0,
                                                    outOfFlightStart: detail.checked ? equipment.outOfFlightStart : "",
                                                    outOfFlightEnd: detail.checked ? equipment.outOfFlightEnd : ""
                                                };
                                                setEquipment(updatedEquipmenet);
                                            }}
                                            checked={equipment.isOutOfFlight === 1}>
                                            Está fuera de vuelo
                                        </Checkbox>

                                        <SpaceBetween direction="horizontal" size="l">
                                            {equipment && equipment.isOutOfFlight === 1 && (
                                                <>
                                                    <FormField label="Inicio">
                                                        <DPModal
                                                            today
                                                            title="Fecha de inicio"
                                                            clear
                                                            date={equipment.outOfFlightStart}
                                                            onConfirm={(date) => {
                                                                const updatedEquipmenet = { ...equipment, outOfFlightStart: date };
                                                                setEquipment(updatedEquipmenet);
                                                            }} />
                                                    </FormField>

                                                    <FormField label="Término">
                                                        <DPModal
                                                            today
                                                            title="Fecha de inicio"
                                                            clear
                                                            date={equipment.outOfFlightEnd}
                                                            onConfirm={(date) => {
                                                                const updatedEquipmenet = { ...equipment, outOfFlightEnd: date };
                                                                setEquipment(updatedEquipmenet);
                                                            }} />
                                                    </FormField>
                                                </>
                                            )}
                                        </SpaceBetween>
                                    </SpaceBetween>
                                </Container>
                                <Container header={<Header variant='h3'>Valores</Header>}>

                                    <SpaceBetween direction="horizontal" size="l">
                                        <FormField label={"Hora de vuelo"}
                                            constraintText={
                                                equipment && data.UF
                                                    ? (equipment.hourCost * data.UF).toLocaleString('es-CL', {
                                                        style: 'currency',
                                                        currency: 'CLP',
                                                        maximumFractionDigits: 0
                                                    }) // optional formatting
                                                    : ""
                                            }
                                        >
                                            <Input value={hourCost || "0"}
                                                type="text"
                                                onChange={(detail) => {
                                                    setHourCost(sanitizeNumber(detail.detail.value));
                                                }}
                                                onBlur={() => {
                                                    // convert to number when input loses focus
                                                    const updatedEquipment = { ...equipment, hourCost: Number(hourCost) };
                                                    setEquipment(updatedEquipment);
                                                }} />
                                        </FormField>
                                        <FormField label={"Liberado despues de"} constraintText="Minutos">
                                            <Input value={hourCostFree || "0"}
                                                type="text"
                                                onChange={(detail) => {
                                                    setHourCostFree(sanitizeNumber(detail.detail.value, 0));
                                                }}
                                                onBlur={() => {
                                                    // convert to number when input loses focus
                                                    const updatedEquipment = { ...equipment, hourCostFree: Number(hourCostFree) };
                                                    setEquipment(updatedEquipment);
                                                }}
                                            />
                                        </FormField>


                                    </SpaceBetween>
                                    {equipment.groupTypeMasterCode === "GLIDER" && (
                                        <>
                                            <hr style={{ border: "1px solid #d1d5db", margin: "16px 0" }} />
                                            <Header variant='h3'>Remolques</Header>

                                            <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
                                                {equipment.jsonAltitudes.map((item: AltitudeItem, index: number) => (

                                                    <FormField
                                                        key={item.altitude}
                                                        label={`${item.altitude} m`}
                                                        constraintText={
                                                            item && item.cost && data.UF
                                                                ? (Number(item.cost) * data.UF).toLocaleString('es-CL', {
                                                                    style: 'currency',
                                                                    currency: 'CLP',
                                                                    maximumFractionDigits: 0
                                                                }) // optional formatting
                                                                : "N/D"
                                                        }
                                                    >
                                                        <Input
                                                            value={item.cost}
                                                            type="text"
                                                            onChange={({ detail }) => handleCostChange(index, sanitizeNumber(detail.value))}
                                                        />
                                                    </FormField>
                                                ))}
                                            </div>
                                        </>
                                    )}
                                </Container>

                                <Container header={<Header variant='h3'
                                    description={<Checkbox checked={equipment?.jsonTowingTimes?.outseason !== undefined}
                                        onChange={(e) => {
                                            if (!e.detail.checked) {
                                                const updatedEquipment = { ...equipment, jsonTowingTimes: {} };
                                                setEquipment(updatedEquipment);
                                            } else {
                                                const updatedEquipment = { ...equipment, jsonTowingTimes: { outseason: { LOCAL: 0, SANRAMON: 0, MOUNTAIN: 0, BALLAST: 0 }, inseason: { LOCAL: 0, SANRAMON: 0, MOUNTAIN: 0, BALLAST: 0 } } };
                                                setEquipment(updatedEquipment);

                                            }
                                        }}>Material tiene tiempos de remolque</Checkbox>
                                    }


                                >Tiempos de remolque</Header>}>
                                    {equipment.jsonTowingTimes.outseason && equipment.jsonTowingTimes.inseason && (
                                        <ColumnLayout columns={2} variant="text-grid">
                                            <div>
                                                <Header variant="h3">En temporada</Header>
                                                <SpaceBetween direction='vertical' size='xs'>
                                                    {Object.entries(equipment.jsonTowingTimes.inseason).map(([key, value], index) => (
                                                        <FormField key={`IN${index}`} label={towTypestring(key)}>
                                                            <Input type='number' value={value as string}
                                                                onChange={({ detail }) => handleTowingChange('inseason', key, detail.value)} />
                                                        </FormField>
                                                    ))}
                                                </SpaceBetween>
                                            </div>
                                            <div>
                                                <Header variant="h3">Fuera temporada</Header>
                                                <SpaceBetween direction='vertical' size='xs'>
                                                    {Object.entries(equipment.jsonTowingTimes.outseason).map(([key, value], index) => (
                                                        <FormField key={`OUT${index}`} label={towTypestring(key)}>
                                                            <Input type='number' value={value as string}
                                                                onChange={({ detail }) => handleTowingChange('outseason', key, detail.value)} />
                                                        </FormField>
                                                    ))}
                                                </SpaceBetween>
                                            </div>
                                        </ColumnLayout>
                                    )}

                                </Container>

                            </SpaceBetween>
                        </Form>
                    )
                    }
                </SpaceBetween >
            }
        />
    )
}
